/**
 * @author vishwadeep.kapoor
 * @Date: 2020-06-17 14:15:23
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-06-17 16:17:38
 */
import endPoints from '../../config/endPoints';
import { IMG_IMPORTS } from '../assests';
import {
  LINK_HOME, LINK_CAREERS, LINK_PRESS, LINK_TEAM, LINK_CONTACTUS, LINK_ABOUT_US, LINK_PROPEL, LINK_EDGE,
  LINK_SAVE, LINK_SELECT, LINK_SAVEPLUS, LINK_EXPENSE_BENIFIT_HTML, LINK_EXPENSE_BENIFIT, LINK_REWARDS_RECOGINITION_HTML,
  LINK_CORPORATE_GIFT_HTML, LINK_CORPORATE_GIFT, LINK_MERCHANT, LINK_GIFTCARD_LANDING, LINK_PAY_BALANCE, LINK_GRIEVANCE_POLICY,
  LINK_REFUND_POLICY, LINK_PRIVACY_POLICY, LINK_FAQS, LINK_TERMS_CONDITIONS, GIFT_CARD_CART, LINK_CALCULATOR, LINK_PARTNER_WITH_US, LINK_GIFTCARD_LIST,
  LINK_EMPLOYEE_FLEXI_BENEFITS, LINK_EDGE_LANDING, LINK_PAYROLL_CARD, CAMPAIGN_MONEYFY, LINK_PAYROLL_CARD_CONTACT,
  CAMPAIGN_GROW_MONEYFY,LINK_CEDITCARD,
  CAMPAIGN_SECURE_MONEYFY,
  LINK_MANAGE_ZAGGLE_CARD,
  LINK_SOLUTIONS_CORPORATE,
  LINK_SOLUTIONS_SME,
  LINK_SOLUTIONS_STARTUP,
  LINK_SPECIAL_DEALS_AND_OFFERS,
  LINK_WEARABLES,
} from '../constants';

const SEO_TAGS = {
  [LINK_HOME]: {
    title: 'Zaggle | Business Spends Simplified',
    description: 'A 360 degree business spend management platform, automating workflows like employee benefits, rewards and recognition, expense management, and integrating with any payment instrument.',
    keywords: 'Global Digital Bank, Financial Technology Company',
    ogtype: 'business',
    twitterdescription: 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.',
  },
  [LINK_CAREERS]: {
    title: ' Join Zaggle | Careers with Zaggle',
    description: 'Find your dream job at Zaggle and build innovative products with us. Be a part of our team and scale new heights of success.',
    keywords: 'Join Zaggle, Career with Zaggle, find job Apply job in Zaggle',
    ogtype: 'website',
    image: endPoints.CAREERS_LANDING_IMAGE.URL,
    twitterdescription: 'Find your dream job at Zaggle and build innovative products with us. Be a part of our team and scale new heights of success.',
    title_dir_prod_ems_save: 'Apply for Director Products - EMS and SAVE, Hyderabad/Mumbai, India (Fulltime)',
    desc_dir_prod_ems_save: 'Define a vision narrative for the team to propel forward. Establish thought leadership and drive the vision in the SaaS industry. Implement a market dominating product strategy by refining the target audience, value propositions, competitor analysis, acquisition & monetization strategy and KPIs.',
    title_dir_prod_edge: 'Apply for Director Product - EDGE, Hyderabad/Mumbai, India (Fulltime)',
    desc_dir_prod_edge: 'Draw a product vision for payments issuance, scale our products and take Zaggle to a leadership position across India and beyond.',
    title_sr_prod_mgr_ems_propel_save: 'Apply for Senior Product Manager, EMS, PROPEL, SAVE and GCLP, Hyderabad, India (Fulltime)',
    desc_sr_prod_mgr_ems_propel_save: 'Build the product roadmap, understand market requirements, and partner with design, engineering, sales and operations to build product features that solve real problems.',
    title_jr_prod_mgr_ems_propel: 'Apply for Junior Product Manager, EMS and PROPEL, Hyderabad, India (Fulltime)',
    desc_jr_prod_mgr_ems_propel: 'Research about the product and industry trends, undertake competitive landscaping, and prepare product catalogues and marketing collaterals.',
    title_business_head_save: 'Apply for Business Head – Save (Expense Management), Mumbai/Delhi/Hyderabad, India (Fulltime)',
    desc_business_head_save: 'Embrace the company’s digital first philosophy to build the Save (Expense management & Reimbursements) business as India’s best SaaS based expense management platform in the next 12-18 months',
    title_ror_dev: 'Apply for Ruby on Rails Developer, Mumbai/Delhi/Hyderabad, India (Fulltime)',
    desc_ror_dev: 'Build and implement software programs on Ruby on Rails along with common libraries such as RSpec, Sidekiq, Redis. Scale a web app with systems architecture and fundamental design principles.',
    title_ai_ml_eng: 'Apply for AI/ML Engineer, Hyderabad, India (Fulltime)',
    desc_ai_ml_eng: 'Machine Learning Engineer responsibilities include creating machine learning models and retraining systems. To do this job successfully, you need exceptional skills in statistics and programming.',
    title_integration_eng: 'Apply for Integration Engineer, Hyderabad, India (Fulltime)',
    desc_integration_eng: 'Build and implement software programs with Java, ROR, JavaScript, Python or PHP and Rails, Django, Android Native, iOS Native, React Native, ReactJS, AngularJS, or Git frameworks. Experience integrating with multiple third-party systems using RESTful, SOAP or custom APIs.',
    title_reactjs_dev: 'Apply for React JS Developer, Hyderabad, India (Fulltime)',
    desc_reactjs_dev: 'Build, deploy and maintain a scalable codebase with React JS and advanced JavaScript libraries and frameworks.',
    title_inside_sales_head: 'Apply for Inside sales Head, Mumbai, India (Fulltime)',
    desc_inside_sales_head: 'Develop new business opportunities, work with the Business Development team to grow the sales pipeline. Prepare and analyze sales pipeline reports',
  },
  [LINK_PRESS]: {
    title: 'Zaggle | Press Releases and News Updates',
    description: 'Stay updated with the latest news and updates from Zaggle. Visit and Read our latest press release, news and statements.',
    keywords: 'Press Release, Press, News update',
    ogtype: 'website',
    image: endPoints.NEWS_LANDING_IMAGE.URL,
    twitterdescription: 'Stay updated with the latest news and updates from Zaggle. Visit and Read our latest press release, news and statements.',
  },
  [LINK_CEDITCARD]: {
    title: 'Zaggle | Credit Cards',
    description: 'Credit Cards',
    keywords: 'Credit Cards',
    ogtype: 'Credit Cards',
    image: endPoints.NEWS_LANDING_IMAGE.URL,
    twitterdescription: 'Credit Cards',
  },
  [LINK_TEAM]: {
    title: 'Zaggle Leadership Team | Support, Service and Solutions',
    description: 'Zaggle has a diverse leadership team that is assisting in creating niche financial products to serve various business needs. Know more about our promising team here.',
    keywords: 'Zaggle Team support, Experts team, Zaggle Team',
    ogtype: 'website',
    image: endPoints.TEAM_LANDING_IMAGE.URL,
    twitterdescription: 'Zaggle has a diverse leadership team that is assisting in creating niche financial products to serve various business needs. Know more about our promising team here.',
  },
  [LINK_SOLUTIONS_CORPORATE]: {
    title: 'Best Option for Employee Flexi Benefits Solutions | Zaggle',
    description: "Zaggle's financial management solutions will help corporates to make informed financial decisions and aid in streamlining their financial operations. Connect with us for corporate finance solutions.",
    keywords: 'Expense Management Solutions | Best Employee Flexi Benefits Solutions',
    ogtype: 'business',
    image: endPoints.BUILT_EVERYONE_CORPORATE.URL,
    twitterdescription: "Zaggle's financial management & analytics tool will help corporates to make informed financial decisions and aid in streamlining their financial operations. Connect with us for corporate finance solutions.",
  },
  [LINK_SOLUTIONS_SME]: {
    title: 'Best Digital Business Finance Management Solutions for SMEs | Zaggle',
    description: 'Zaggle is a financial management solution that helps SMEs to make informed financial decisions and aid in streamlining their financial operations. Visit our website for further information.',
    keywords: 'Digital Finance Solution for SMEs, best Finance Solution for SMEs',
    ogtype: 'website',
    image: endPoints.BUILT_EVERYONE_SMES.URL,
    twitterdescription: 'Zaggle is a financial management solution that helps SMEs to make informed financial decisions and aid in streamlining their financial operations. Visit our website for further information.',
  },
  [LINK_SOLUTIONS_STARTUP]: {
    title: 'Payroll Software for Startups and Small Business| Zaggle',
    description: "Zaggle is a one-time solution for all types of businesses. We offer startup businesses with the right solutions and are an integral part of maintaining the company's finances. Call us now!",
    keywords: 'Payroll Solution for Startup business, Manage payroll for startup',
    ogtype: 'business',
    image: endPoints.BUILT_EVERYONE_STARTUP.URL,
    twitterdescription: 'Zaggle is a one-time solution for all types of business. We offer startup businesses with the right solutions and are an integral part of maintaining the company’s finances. Call us now!',
  },
  [LINK_CONTACTUS]: {
    title: 'Contact Us | Zaggle Corporate Solutions',
    description: 'Do you expand your business? Ask all your questions about products and pricing and at Zaggle, we ensure to provide exceptional service to you.',
    keywords: 'Contact Zaggle, Zaggle Corporate Solutions Contact',
    ogtype: 'website',
    image: endPoints.CONTACT_US_LANDING_IMAGE.URL,
    twitterdescription: 'Do you expand your business? Ask all your questions about products and pricing and at Zaggle, we ensure to provide exceptional service to you.',
  },
  [LINK_MANAGE_ZAGGLE_CARD]: {
    title: 'Gift Cards | E-Gift Cards Platform | Manage your Payment Card',
    description: 'Making gifting easy for everyone, our gift cards are an excellent choice for corporate gifts to employees and channel partners. Visit www.zaggle.in to purchase your e-gift card.',
    keywords: 'Manage Payment Card, Make Payment, Gift Cards, E Gift card platform',
    ogtype: 'business',
    image: endPoints.LOGIN_CARD.URL,
    twitterdescription: 'Making gifting easy for everyone, our gift cards are an excellent choice for corporate gifts to employees and channel partners. Visit www.zaggle.in to purchase your e-gift card.',
  },
  [LINK_ABOUT_US]: {
    title: 'About us | Spend Management Solutions | Zaggle',
    description: 'Zaggle builds world-class financial solutions and products to manage the business expenses of corporates, SMEs, & Startups through automated and innovative workflows.',
    keywords: 'Best Digital Bank in the World, Fintech Companies in India',
    ogtype: 'business',
    image: endPoints.ABOUT_US_LANDING.URL,
    twitterdescription: 'Zaggle builds world-class financial solutions and products to manage the business expenses of corporates, SMEs, & Startups through automated and innovative workflows.',
  },
  [LINK_PROPEL]: {
    title: 'Employee Rewards & Recognition | Channel Incentive Program',
    description: 'Rewards and Recognition programs help companies to appreciate and motivate employees and improve the overall employee morale and productivity',
    keywords: '',
  },
  [LINK_EDGE]: {
    title: 'Corporate Gifts for Employees | Corporate Gifting',
    description: 'Reward your employees with the help of the best corporate gifting company. Use Zaggle Edge gift cards for employee gifting and boost employee morale.',
    keywords: 'Corporate Gifting Companies, Employee Gifting',
  },
  [LINK_SAVE]: {
    title: 'Expense Management Software | Business Expense Management| Travel Reimbursement',
    description: 'An all-in-one business expense management platform that empowers your businesses to spend smarter, therefore, saving time and increasing productivity.',
    keywords: '',
  },
  [LINK_SELECT]: {
    title: 'Customized corporate solutions :: Zaggle Select',
    description: 'We design, develop & deliver proprietary tech platforms to enhance productivity and efficiency',
    keywords: '',
  },
  [LINK_SAVEPLUS]: {
    title: 'Employee Tax Benefits | Corporate Solutions :: Zaggle Save',
    description: 'Our multi-wallet card which includes Meal, Fuel, LTA, Gift wallets enables employers to have hassle-free funds disbursement.',
    keywords: '',
  },

  [LINK_EXPENSE_BENIFIT]: {
    title: 'Automated Travel and Expense Management Software :: Zaggle Save',
    description: 'Simplify travel, employee expense and invoice management with automatic expense reports tracking using our web and mobile based solution, Zaggle Save',
    keywords: '',
  },
  [LINK_EXPENSE_BENIFIT_HTML]: {
    title: 'Automated Travel and Expense Management Software :: Zaggle Save',
    description: 'Simplify travel, employee expense and invoice management with automatic expense reports tracking using our web and mobile based solution, Zaggle Save',
    keywords: '',
  },
  [LINK_REWARDS_RECOGINITION_HTML]: {
    title: 'Rewards & Recognition | Channel Incentive :: Zaggle Propel',
    description: 'Recognise your employees, channel partners and customers & reward them for their achievements with our customisable platform, Zaggle Propel',
    keywords: '',
  },
  [LINK_CORPORATE_GIFT]: {
    title: 'Prepaid Gift Cards | Corporate Gifting :: Zaggle Edge',
    description: 'Make corporate gifting for employees on festive occasions, work anniversaries, birthdays or any milestones even more personalised with gift cards for each occasion, Zaggle Edge',
    keywords: '',
  },
  [LINK_CORPORATE_GIFT_HTML]: {
    title: 'Prepaid Gift Cards | Corporate Gifting :: Zaggle Edge',
    description: 'Make corporate gifting for employees on festive occasions, work anniversaries, birthdays or any milestones even more personalised with gift cards for each occasion, Zaggle Edge',
    keywords: '',
  },
  [LINK_MERCHANT]: {
    title: 'Merchant Gift Card Solutions :: Zaggle',
    description: 'Reward your customer with a personalized gift cards. Our custom branding solutions helps businesses personalize their gifting.',
    keywords: '',
  },
  [LINK_GIFTCARD_LANDING]: {
    title: 'Gift Cards and Vouchers | Gift Card Offers | Zaggle',
    description: 'Discover online gift cards and vouchers from over 100 brands at one place, along with some incredible deals and discounts. Check out the best gift card offers with us!',
    keywords: 'Best Gift Card Deals, Employee Gift Card, Gift Voucher, Best gift Card Deal',
    ogtype: 'business',
    image: endPoints.LOGIN_CARD.URL,
    twitterdescription: 'Discover online gift cards and vouchers from over 100 brands at one place, along with some incredible deals and discounts. Check out the best gift card offers with us!',
  },
  [LINK_PAY_BALANCE]: {
    title: 'Check your balance | Find your Cards :: Zaggle',
    description: 'Check all your transactions and balance in your Zaggle cards real-time with a single login',
    keywords: '',
  },
  [LINK_GRIEVANCE_POLICY]: {
    title: 'Grievance Policy :: Zaggle',
    description: 'Zaggle realizes that quick and effective handling of customer grievance, as well as prompt corrective & preventive actions to improve processes are essential to provide excellent customer service to all segments of customers',
    keywords: '',
  },
  [LINK_REFUND_POLICY]: {
    title: 'Refund Policy :: Zaggle',
    description: 'Know more about our refund policy',
    keywords: '',
  },
  [LINK_PRIVACY_POLICY]: {
    title: 'Privacy Policy :: Zaggle',
    description: 'Zaggle respects the privacy of its users and is committed to protect it in all respects',
    keywords: '',
  },
  [LINK_FAQS]: {
    title: 'FAQ`s :: Zaggle',
    description: 'Find a solution to all your queries and issues when using any of our products and services from our Frequently Asked Questions page',
    keywords: '',
  },
  [LINK_TERMS_CONDITIONS]: {
    title: 'Terms and Conditions :: Zaggle',
    description: 'Terms and conditions are the legal agreements, rights and responsibilities between Zaggle and the client',
    keywords: '',
  },
  [GIFT_CARD_CART]: {
    title: 'Shopping Cart :: Zaggle',
    description: 'Purchase Gift Cards for Fashion, Electronics, Restaurants, Home needs, Travel, Entertainment, Wellness, Jewellery, Stationary etc with the best offers',
    keywords: '',
  },
  [LINK_CALCULATOR]: {
    title: 'Expense Management | Value Calculator :: Zaggle',
    description: 'If your company were to automate expense management with Zaggle Save, check out the savings you would be able to achieve every month.',
    keywords: '',
  },
  [LINK_PARTNER_WITH_US]: {
    title: 'Become a Partner with Zaggle',
    description: 'By partnering with Zaggle, you can strengthen your offering, win more business, and expand your footprint with your clients.',
    keywords: 'Zaggle Partner, Become a Partner with Zaggle',
    ogtype: 'website',
    image: endPoints.PARTNER_WITH_US.URL,
    twitterdescription: 'By partnering with Zaggle, you can strengthen your offering, win more business, and expand your footprint with your clients.',
  },
  [LINK_GIFTCARD_LIST]: {
    title: 'Buy our Gift Cards :: Zaggle',
    description: 'Choose our gift cards from our fantastic range of Gift Vouchers, Gift Cards, E-Gift Vouchers and E-Gift Cards. Gift to your loved ones for all occasions.',
    keywords: '',
  },
  [LINK_SPECIAL_DEALS_AND_OFFERS]: {
    title: 'Buy our Gift Cards :: Zaggle',
    description: 'Choose our gift cards from our fantastic range of Gift Vouchers, Gift Cards, E-Gift Vouchers and E-Gift Cards. Gift to your loved ones for all occasions.',
    keywords: '',
  },
  [LINK_EMPLOYEE_FLEXI_BENEFITS]: {
    title: 'Employee Flexible Benefits | Employee Benefits',
    description: 'Employee Benefits are the employee flexible benefits that an organisation offer to their employees in their CTC, which will help employees reduce their tax liability.',
    keywords: 'Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits, Meal Benefits, Fuel Benefits, Gift Allowance, Employee Allowance, It Complaint, LTA, Telecom and Broadband Benefits, Driver Allowance, Uniform Allowance, Multi wallet Card',
  },
  [LINK_EDGE_LANDING]: {
    title: 'Corporate Gifts for Employees | Corporate Gifting',
    description: 'Reward your employees with the help of the best corporate gifting company. Use Zaggle Edge gift cards for employee gifting and boost employee morale.',
    keywords: 'Corporate Gifting Companies, Employee Gifting',
  },
  [`${LINK_EDGE_LANDING}/kuber-gift-card`]: {
    title: 'Corporate Gift Card | Gift Card for Employees',
    description: 'Zaggle Edge\'s Kuber Gift Card brings you a wholesome corporate gift card as a digital gift card to share happiness with employees, customers, clients or vendors. Use Kuber Virtual Gift Card for various gifting occasions and send incentives to your workforce.',
    keywords: 'Digital Gift Card, Virtual Gift Card',
  },
  [`${LINK_EDGE_LANDING}/wave-gift-card`]: {
    title: 'Gift Cards in India | Corporate Gift Vouchers',
    description: 'Appreciate, recognize and reward your employees with Zaggle’s Wace Corporate Gift Card, India. Award your workforce with corporate gift vouchers with our employee rewards and recognition program and employee appreciation program.',
    keywords: 'Employee Appreciation',
  },
  [`${LINK_EDGE_LANDING}/kohinoor-gift-card`]: {
    title: 'Jewellery Gift Card | Festive Gifting',
    description: 'Zaggle\'s Kohinoor Gift Card is the best employee gift idea to reward your workforce. Your employees can use this Jewellery Gift Card at all the prominent outlets of jewellery all over India. Thinking of festive gifting? Kohinoor Jewelley Gift Card is best you can get..',
    keywords: 'Employee Gift Ideas',
  },
  [LINK_PAYROLL_CARD]: {
    title: 'Best Payroll Card Service for Employees in India | Zaggle.in',
    description: 'Zaggle.in offers the best payroll card services for your employees. Streamline your payroll activities with digital payment solutions instead of disbursing cash or cheques. Know more about our payroll card services.',
    keywords: 'Payroll Cards, Payroll Card for Employees, Employee Payroll Card, Paycard for Payroll, Payroll card Providers, Payroll Card Services, Payroll Card Solutions, Best Payroll card for Employees, Best Payroll card Providers',
    ogtype: 'business',
    image: endPoints.PAYROLL_CARD_LANDING_IMAGE.URL,
    twitterdescription: 'Zaggle.in offers the best payroll card services for your employees. Streamline your payroll activities with digital payment solutions instead of disbursing cash or cheques. Know more about our payroll card services.',
  },
  [LINK_PAYROLL_CARD_CONTACT]: {
    title: 'Contact Us: Best Payroll solution | Zaggle Payroll Card',
    description: 'Access seamless digital payment services with Zaggle.in. Our convenient and powerful payroll card services help manage your employee payments. Payroll cards work like debit cards, with additional features. Get in touch with us for further information.',
    keywords: 'Best Payroll solution | Zaggle Payroll Card',
    ogtype: 'business',
    image: endPoints.PAYROLL_CARD_LANDING_IMAGE.URL,
    twitterdescription: 'Access seamless digital payment services with Zaggle.in - a top digital bank in India. Our convenient and powerful payroll card services help manage your employee payments.',
  },
  [LINK_PAYROLL_CARD_CONTACT]: {
    title: 'Payroll Card | Contact Us | Best Payroll Cards for Employees',
    description: 'Looking for the best payroll card for employees? Zaggle Employee Payroll Card allows companies to issue payment by card to unbanked workforce instead of disbursing cash or cheques.',
    keywords: 'Employee Payroll Card, Pay Cards for Payroll, Payroll Card Providers',
  },
  [CAMPAIGN_MONEYFY]: {
    title: 'Invest in Mutual Funds',
    description: 'Grow your wealth through suitable investments in Moneyfy via Zaggle.',
    keywords: '',
  },
  [LINK_PAYROLL_CARD_CONTACT]: {
    title: 'Payroll Card | Contact Us | Best Payroll Cards for Employees',
    description: 'Looking for the best payroll card for employees? Zaggle Employee Payroll Card allows companies to issue payment by card to unbanked workforce instead of disbursing cash or cheques.',
    keywords: 'Employee Payroll Card, Pay Cards for Payroll, Payroll Card Providers',
  },
  [CAMPAIGN_GROW_MONEYFY]: {
    title: 'Grow with Moneyfy - Zaggle',
    description: 'Now get access to best-in-class investment products with MoneyfyxZaggle to achieve your financial goals! | Invest in Top Fund| Tax saver funds| SIP @500',
  },
  [CAMPAIGN_SECURE_MONEYFY]: {
    title: 'Secure with Moneyfy - Zaggle',
    description: 'Now get access to best-in-class investment products with MoneyfyxZaggle to achieve your financial goals! | Invest in Top Fund| Tax saver funds| SIP @500',
  },
  [LINK_WEARABLES]: {
    title: 'Wearables | KeyFob | Zaggle',
    description: 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.',
    keywords: 'Best Digital Bank in the World, Fintech Companies in India',
    ogtype: 'business',
    image: IMG_IMPORTS.WEARABLES_GADGET_IMAGE.URL,
    twitterdescription: 'The world’s best Digital Bank is now in India. Get ready to experience effortless banking in a safe and secure way. Visit us at www.zaggle.in for further information.',
  },
};

export { SEO_TAGS };



// WEBPACK FOOTER //
// client/devUtils/analytics/seoTags.js